import qs from "qs";
import { mapState } from "vuex";
import request from "@/utils/request";
import { personMenuList, personSeller } from "./menu";

export default {
  data() {
    return {
      project: [
        {
          name: "企采采",
          value: "qcc",
        },
        {
          name: "企商城",
          value: "qsc",
        },
        {
          name: "企店Pro",
          value: "qd",
        },
        {
          name: "移动访销",
          value: "qdfx",
        },
        {
          name: "供应链金融",
          value: "gyljr",
        },
      ],
      projectActive: "qcc",
      loading: null,
      menuList: [],
      inIframe: false,
      isCollapse: false,
    };
  },
  computed: {
    projectName: function () {
      const { project, projectActive } = this;
      return project.find((item) => item.value == projectActive).name;
    },
    ...mapState({
      org: (state) => state.site.org,
      factory: (state) => state.site.factory,
      currentId: (state) => state.site.currentId,
    }),
  },
  async created() {
    const body = document.querySelector("body");
    body.classList.add("seller-style");

    if (self != top) {
      this.inIframe = true;
    } else {
      this.inIframe = false;
    }

    this.loading = this.$loading({
      lock: true,
      text: "加载中...",
    });

    const { code, data, msg } = await request.get(`nxin.usercenter.enterprise.list/7.0?source=0`);
    if (code == 0) {
      this.$store.commit("site/setOrgList", data.orgList);
      this.$store.commit("site/setCurrentId", data.current);

      if (data.orgList && data.orgList[0].IsDefault) {
        this.$store.commit("site/setOrg", data.orgList[0]);
        this.$store.commit("site/setFactoryList", data.orgList[0].ChildEnterprise);
        const index = data.orgList[0].ChildEnterprise.findIndex((item) => item.IsDefault);
        if (index != -1) {
          this.$store.commit("site/setFactory", data.orgList[0].ChildEnterprise[index]);
        }
      }
      this.isSetUpShop();
    } else {
      this.$message.error(msg);
    }
  },
  methods: {
    // 是否开店
    async isSetUpShop() {
      const {
        org: { ID },
        currentId,
      } = this;
      const { code, data, msg } = await request.post(
        `nxin.sc.isSetUpShop.get/1.0`,
        qs.stringify({
          orgid: ID ? ID : currentId,
        })
      );
      if (code == 0) {
        if (ID) {
          if (data) {
            this.getShoplist();
          } else {
            const { factory } = this;
            this.getMenulist({ iPlat: 2, enterpriseId: ID, threetype: factory.Systems, iEnteSortID: factory.ID });
          }
        } else {
          if (data) {
            this.initMenu(personSeller);
          } else {
            this.initMenu(personMenuList);
          }
        }
      } else {
        this.$message.error(msg);
      }
    },
    // 获取店铺列表及默认店铺
    async getShoplist() {
      const { code, data, msg } = await request.get("nxin.sc.shoplist.list/2.0");
      if (code == 0) {
        this.$store.commit("site/setShopList", data);
        const shop = data.find((item) => item.isDefault == 1);
        this.$store.commit("site/setShop", shop);
        this.getMenulist({ iPlat: 2, enterpriseId: this.org.ID, iEnteSortID: shop.shopIdStr });
      } else {
        this.$message.error(msg);
      }
    },
    // 获取菜单
    async getMenulist(params) {
      const { code, data, msg } = await request.get(`nxin.permission.qlwpc.menulist/3.0?${qs.stringify(params)}`);
      if (code == 0) {
        this.initMenu(data);
      } else {
        this.$message.error(msg);
      }
    },
    // 初始化菜单
    initMenu(data) {
      data.forEach((item) => {
        if (item.child && item.child.length == 1) {
          item.child = item.child[0].child;
        } else if (item.child && item.child.length > 1) {
          item.child.forEach((child) => {
            if (child.child && child.child.length == 1) {
              child.child = child.child[0].child;
            }
          });
        }
      });
      this.menuList = data;
      console.log("initMenu-data", data);
    },
  },
};
